import {
    COLOR
} from '../../business-const/Color/Color'



// a little function to help us with reordering the result
export const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
}

/**
 * Moves an item from one list to another list.
 */
export const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source)
    const destClone = Array.from(destination)
    const [removed] = sourceClone.splice(droppableSource.index, 1)

    destClone.splice(droppableDestination.index, 0, removed)

    const result = {}
    result[droppableSource.droppableId] = sourceClone
    result[droppableDestination.droppableId] = destClone

    return result
}

const grid = 8

export const getItemStyle = (isDragging, draggableStyle, theme, obrigatorio, especial) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    boxShadow: theme.shadows[4],
    borderRadius: '4px',
    // change background colour if dragging
    background: isDragging
        ? COLOR().bgDragDropTwoListItemIsDraggingOver//'rgba(var(--primary),1)'
        : obrigatorio
            ?
                COLOR().bgDragDropTwoListItemObrigatorio
            :
                especial
                    ?
                        COLOR().bgDragDropTwoListItemEspecial
                    :
                        COLOR().bgDragDropTwoListItem,//'rgba(var(--bg-paper),1)',

    // styles we need to apply on draggables
    ...draggableStyle,
})

export const getListStyle = (isDraggingOver) => ({
    borderRadius: '4px',
    background: isDraggingOver
        ? COLOR().bgDragDropTwoListListIsDraggingOver//'rgba(0,0,0, .1)'
        : COLOR().bgDragDropTwoListList,//'rgba(var(--bg-default),1)',
    padding: grid,
    width: 450,
})